import { Link } from "react-router-dom";
import ImageSlider from "./ImageSlider";

export default function ProjectView({ project }) {
  if (!project) {
    return (
      <div className="max-w-4xl mx-auto text-center py-20 text-slate-500">
        <Link
          to="/portfolio"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-xl
                     bg-slate-100 hover:bg-slate-200
                     text-slate-800 font-medium transition"
        >
          ← Назад к портфолио
        </Link>
        <div className="mt-4">Проект не найден</div>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto">
      <div className="sticky top-3 z-30 mb-6 rounded-2xl border border-slate-200 bg-white/90 backdrop-blur-xl p-3 sm:p-4 shadow-[0_8px_24px_rgba(15,23,42,0.08)]">
        <div className="flex items-center justify-between gap-3">
          <Link
            to="/portfolio"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-xl
                       bg-slate-100 hover:bg-slate-200
                       text-slate-800 font-medium transition"
          >
            ← К портфолио
          </Link>

          <a
            href="/#teacher"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-xl
                       bg-white border border-slate-200 hover:bg-slate-50
                       text-slate-700 font-medium transition"
          >
            К преподавателю
          </a>

          <Link
            to="/portfolio"
            className="flex items-center justify-center w-10 h-10 rounded-full
                       bg-slate-100 hover:bg-slate-200
                       text-slate-600 hover:text-slate-900
                       transition"
            aria-label="Закрыть"
          >
            ✕
          </Link>
        </div>
      </div>

      <article className="rounded-3xl border border-slate-200 bg-white p-5 sm:p-8 shadow-[0_16px_36px_rgba(15,23,42,0.1)]">
        <p className="inline-flex rounded-full bg-slate-100 px-3 py-1 text-xs font-medium uppercase tracking-wide text-slate-600">
          Проект из портфолио
        </p>
        <h1 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
          {project.title}
        </h1>

        {project.description && (
          <p className="mt-4 text-slate-600 text-base leading-relaxed">{project.description}</p>
        )}

        {project.category === "model" && (
          <>
            <section className="mt-10">
              <h2 className="font-semibold text-xl text-slate-900">Фото и рендеры</h2>
              <ImageSlider images={project.modelImages} />
            </section>

            {project.modelLink && (
              <a
                href={project.modelLink}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center mt-8 px-4 py-2 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-medium transition"
              >
                Скачать модель →
              </a>
            )}
          </>
        )}

        {project.category === "pasport" && (
          <>
            <section className="mt-10">
              <h2 className="font-semibold text-xl text-slate-900">Паспорт изделия</h2>
              <p className="mt-2 text-slate-600">{project.text}</p>
              <ImageSlider images={project.passportImages} />
            </section>

            {project.downloadLink && (
              <a
                href={project.downloadLink}
                className="inline-flex items-center mt-8 px-4 py-2 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-medium transition"
              >
                Скачать паспорт →
              </a>
            )}
          </>
        )}

        {project.category === "client" && (
          <>
            <section className="mt-10">
              <h2 className="font-semibold text-xl text-slate-900">Чертежи для согласования</h2>
              <ImageSlider images={project.clientImages} />
            </section>

            {project.downloadLink && (
              <a
                href={project.downloadLink}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center mt-8 px-4 py-2 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-medium transition"
              >
                Скачать оригинал →
              </a>
            )}
          </>
        )}
      </article>
    </div>
  );
}
